import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import  { CaseAddManualDto, CaseDelete, CaseDto, CaseFilterDto, CaseFollowUpTaskDetailDto, CaseFollowUpTaskPaged, CaseList, CaseReportFilterDto, CasesFilter,CasesPaged, FlatCaseFilterDto, ReOpenCase, ReportCasesList, ReportCasesPaged, SaveCaseDto } from "app/models/cases/cases-list.model";
import { ReportRequestPagedDto } from "app/models/reports.model";
import { WorkflowReviewDto } from "app/models/workflow/workflow-step-instance.interface";
import { Observable, of } from "rxjs";
import { ConfigsLoaderService } from "./config-loader.service";
import { AlertFilter, AlertFilterFlatReport } from "app/models/alerts/alert-list.model";

@Injectable({
    providedIn: 'root'
})

export class CaseService {

    private readonly useMockData = false;
    private readonly apiEndpoint: string;

    constructor(
        private httpClient: HttpClient,
        private config: ConfigsLoaderService,
    ) {
        this.apiEndpoint = this.config.apiUrl;
    }

    getPaged(filter: CasesFilter): Observable<CasesPaged>{
        return this.httpClient.post<CasesPaged>(`${this.apiEndpoint}/Case/getPaged`, filter);
    }

    addManual(caseManual: CaseAddManualDto): Observable<any>{
        return this.httpClient.post(`${this.apiEndpoint}/Case/AddManual`, caseManual);
    }

    getCase(id: number): Observable<CaseDto>{
        return this.httpClient.get<CaseDto>(`${this.apiEndpoint}/Case/Get/${id}`);
    }

    saveProgress(caseProgress: SaveCaseDto){
        return this.httpClient.post(`${this.apiEndpoint}/Case/SaveProgress`, caseProgress);
    }

    completeStep(caseProgress: SaveCaseDto){
        return this.httpClient.post(`${this.apiEndpoint}/Case/CompleteStep`, caseProgress);
    }

    finalizeStepInstace(workflowReview: WorkflowReviewDto){
        return this.httpClient.post(`${this.apiEndpoint}/Case/FinalizeStepInstance`, workflowReview);
    }

    deleteCase(caseDelete: CaseDelete){
        return this.httpClient.delete(`${this.apiEndpoint}/Case`, {body: caseDelete} );
    }

    reOpenCase(caseToReopen: ReOpenCase){
        return this.httpClient.post(`${this.apiEndpoint}/Case/Reopen`, caseToReopen);
    }

    getPagedFollowUpTaks(data: CaseFilterDto ): Observable<CaseFollowUpTaskPaged>{
        return this.httpClient.post<CaseFollowUpTaskPaged>(`${this.apiEndpoint}/Case/GetPagedFollowUpTaks`, data);
    }

    getFollowUpTaskComments(caseId, caseFollowUpTaskId): Observable<CaseFollowUpTaskDetailDto>{
        return this.httpClient.get<CaseFollowUpTaskDetailDto>(`${this.apiEndpoint}/Case/GetFollowUpTaskComments?caseId=${caseId}&caseFollowUpTaskId=${caseFollowUpTaskId}`);
    }

    saveFollowUpTask(data){
        return this.httpClient.post(`${this.apiEndpoint}/Case/SaveFollowUpTask`, data);
    }

    deleteCaseFollowUpTaskComment(data){
        return this.httpClient.post(`${this.apiEndpoint}/Case/DeleteCaseFollowUpTaskComment`, data);
    }

    generateReportCase(generateReportFilter: CaseReportFilterDto): Observable<any> {
        return this.httpClient.post<any>(`${this.apiEndpoint}/Case/GenerateReport`, generateReportFilter);
    }

    getReportPaged(filter: FlatCaseFilterDto): Observable<any>{
        return this.httpClient.post<any>(`${this.apiEndpoint}/Report/RequestCaseReport`, filter)
    }

    getDetailReports(data: ReportRequestPagedDto ): Observable<ReportCasesList>{
        return this.httpClient.post<ReportCasesList>(`${this.apiEndpoint}/Report/GetDetail`, data)
    }

    backToResquestReport(id: number){
        return this.httpClient.post(`${this.apiEndpoint}/Report/BackToRequestReport/${id}`, id)
    }
    
    deleteFlatReport(id: number){
        return this.httpClient.post<void>(`${this.apiEndpoint}/Report/DeletedRequestReport/${id}`, id);
    }

    getPagedByAlert(alertFilter: AlertFilter): Observable<CasesPaged>{
        return this.httpClient.post<CasesPaged>(`${this.apiEndpoint}/Case/GetPagedByAlerts`, alertFilter);
    }
    
    getReportByAlert(filter: AlertFilterFlatReport): Observable<any>{
        return this.httpClient.post<any>(`${this.apiEndpoint}/Report/RequestCaseByAlertReport`, filter)
    }
}